import React from 'react';
import { useTranslation } from 'react-i18next';
import { HomeTaskView } from '@/components/HomeTaskModal/HomeTaskView';
import { Modal } from '@/components/Modal';

interface Props {
  homeTaskId: number;
  onClose: () => void;
}

export const HomeTaskModal: React.FC<Props> = ({ homeTaskId, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen
      label={t('diary.homeTask.submitAnswers')}
      className="md:h-[788px] md:max-h-[85svh] md:w-[min(853px,calc(100vw-40px))]"
      onClose={onClose}
    >
      <HomeTaskView homeTaskId={homeTaskId} onClose={onClose} />
    </Modal>
  );
};
